import _ from 'lodash';

export const handleRelatedFields = (selectedFields, allFieldsGroups, selectedSheet) => {
  const allFields = _.flatMap(allFieldsGroups, f => f.child);
  const updatedFields = _.cloneDeep(selectedFields);

  _.forEach(selectedFields, selected => {
    const baseExpression = selected.expression.replace("_cpa", "");
    const matchingFields = _.filter(allFields, field => field.expression === baseExpression);

    _.forEach(matchingFields, match => {
      if (!_.some(updatedFields, { expression: match.expression })) {
        updatedFields.push({
          ...match,
          sheet: selectedSheet
        })
      }
    })
  })

  return updatedFields;
}

